import { Trans } from 'react-i18next';

import { DropZoneWrapper, IconWrapper, UploadText, ColoredText } from './DropZone.styles';

import { Icon } from '@/components/Icon';

interface DropZoneProps {
  acceptedTypes?: string[];
}
const ICON_SIZE = 16;

export const DropZone: React.FC<DropZoneProps> = ({ acceptedTypes = [] }) => {
  const formatAcceptedTypes = () => {
    if (!acceptedTypes || acceptedTypes.length === 0) return '';
    return acceptedTypes.map(type => type.replace('*', '')).join(', ');
  };

  const fileTypesText = formatAcceptedTypes();

  return (
    <DropZoneWrapper>
      <IconWrapper>
        <Icon i="Upload" size={ICON_SIZE} />
      </IconWrapper>
      <UploadText>
        <Trans
          i18nKey={`DefaultTranslations:DRAG_FILES_HERE`}
          values={{ fileTypes: fileTypesText }}
          components={{
            span: <ColoredText />
          }}
        />
      </UploadText>
    </DropZoneWrapper>
  );
};
